module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/icon_open-4d770d15dff9d99acb61b470b656ecc0.svg";